import { copyDirective } from "./customDirective";

export function useDirective(app) {
    copyDirective(app)
}